import {Component, OnInit} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

declare let gtag: any;

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.css']
})
export class ShareComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ShareComponent>) {
  }

  ngOnInit() {
  }

  onJustClick(socialType, href: string) {
    if (gtag) {
      gtag('event', 'click', {
        event_category: 'shared',
        event_label: href,
        // 'transport_type': 'beacon'
        // 'event_callback': function() {
        //   document.location = href;
        // }
      });
    }
    this.dialogRef.close();
  }
}
